/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ChargepointConsumptionRequestBuilderRequestsMetadata, type ChargepointConsumptionRequestBuilder } from './chargepointConsumption/index.js';
// @ts-ignore
import { ChargepointConsumptionEnqueueRequestBuilderRequestsMetadata, type ChargepointConsumptionEnqueueRequestBuilder } from './chargepointConsumptionEnqueue/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /fetch
 */
export interface FetchRequestBuilder extends BaseRequestBuilder<FetchRequestBuilder> {
    /**
     * The chargepointConsumption property
     */
    get chargepointConsumption(): ChargepointConsumptionRequestBuilder;
    /**
     * The chargepointConsumptionEnqueue property
     */
    get chargepointConsumptionEnqueue(): ChargepointConsumptionEnqueueRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const FetchRequestBuilderUriTemplate = "{+baseurl}/fetch";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FetchRequestBuilderNavigationMetadata: Record<Exclude<keyof FetchRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    chargepointConsumption: {
        requestsMetadata: ChargepointConsumptionRequestBuilderRequestsMetadata,
    },
    chargepointConsumptionEnqueue: {
        requestsMetadata: ChargepointConsumptionEnqueueRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
